import { render, staticRenderFns } from "./SgEmailConfirmPage.vue?vue&type=template&id=e6672a82&"
import script from "./SgEmailConfirmPage.vue?vue&type=script&lang=js&"
export * from "./SgEmailConfirmPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports